/* eslint camelcase: 0 */
import { omit } from 'lodash';
import { compose } from 'lodash/fp';
import React from 'react';
import { connect } from 'react-redux';
import { autosaveFail } from 'actions/editor';
import elementsActions from 'actions/editor/elements';
import { TabbedElementTypes } from 'constants/tabbedElementTypes';
import ElementBase from '../base';
import Conversation from '../conversation';
import ElementHeader from './ElementHeader';
import TabbedElements from './TabbedElements';
import NonTabbedElements from './NonTabbedElements';

class QuestionElement extends React.Component {
  static defaultProps = {
    hasOptions: true,
  };

  get options() {
    const {
      parent_id: parentId,
      content: { options },
    } = this.props;
    // hide the required object when inside a question bank
    return parentId ? omit(options, 'required') : options;
  }

  render() {
    const {
      applyChanges,
      question_automated_analysis,
      can_add_automated_analysis,
      content,
      handleUpdate,
      handleCommentUpdate,
      handleQuestionMetadataUpdate,
      handleExampleRecordingError,
      hasOptions,
      id,
      requestUpdateAndApplyChanges,
      handleCriteriaUpdate,
    } = this.props;
    const { question_type: questionType } = content;

    const isTabbedElement = TabbedElementTypes.includes(questionType);

    if (questionType === 'conversation') {
      return <Conversation {...this.props} />;
    }

    return (
      <div className="EditorElement-content">
        <ElementHeader
          hasOptions={hasOptions}
          content={content}
          options={this.options}
          id={id}
          handleUpdate={handleUpdate}
          applyChanges={applyChanges}
          isTabbedElement={isTabbedElement}
        />

        {isTabbedElement ? (
          <TabbedElements
            applyChanges={applyChanges}
            handleUpdate={handleUpdate}
            content={content}
            options={this.options}
            handleCriteriaUpdate={handleCriteriaUpdate}
            handleCommentUpdate={handleCommentUpdate}
            handleQuestionMetadataUpdate={handleQuestionMetadataUpdate}
            questionAutomatedAnalysis={question_automated_analysis}
            canAddAutomatedAnalysis={can_add_automated_analysis}
            addAutomatedAnalysisKeywordPath={
              this.props.add_automated_analysis_keyword_path
            }
            getAutomatedAnalysisKeywordsPath={
              this.props.get_automated_analysis_keywords_path
            }
            removeAutomatedAnalysisKeywordPath={
              this.props.remove_automated_analysis_keyword_path
            }
            onError={handleExampleRecordingError}
            isAdmin={this.props.currentUser.isAdmin}
          />
        ) : (
          <NonTabbedElements
            content={content}
            applyChanges={applyChanges}
            handleUpdate={handleUpdate}
            requestUpdateAndApplyChanges={requestUpdateAndApplyChanges}
          />
        )}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch, { id }) => ({
  handleUpdate(changes) {
    dispatch(elementsActions.update(id, changes));
  },
  handleCriteriaUpdate(changes) {
    dispatch(elementsActions.updateCriteria(id, changes));
  },
  handleCommentUpdate(changes) {
    dispatch(elementsActions.updateComments(id, changes));
  },
  handleQuestionMetadataUpdate(changes) {
    dispatch(elementsActions.updateQuestionMetadata(id, changes));
  },
  handleExampleRecordingError() {
    dispatch(autosaveFail());
  },
});

export default compose(
  connect(null, mapDispatchToProps),
  ElementBase,
)(QuestionElement);
